// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__YZiJM","icon":"SortAdornment_icon__2ibIH","up":"SortAdornment_up__iihjX","down":"SortAdornment_down__1EIV6","active":"SortAdornment_active__2y22E"};